import { Component, OnInit, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { Job, JobType } from 'src/app/core/data/entities';
import { InputDialogComponent } from 'src/app/shared/shared.module';
import { TimeAddDialogComponent } from 'src/app/time/time-add-dialog/time-add-dialog.component';

@Component({
    selector: 'app-active-job-search',
    templateUrl: './active-job-search.component.html',
    styleUrls: ['./active-job-search.component.scss'],
    standalone: false
})
export class ActiveJobSearchComponent implements OnInit {
    jobs: any;
    workOrderList: any[];
    showAllOrders = false;
    filter: any;
    jobTypes: JobType[];

    salesMode = false;
    ordersMode = false;
    claimButtonDisable = true;
    unclaimButtonDisable = true;
    woAddedSubscription: Subscription;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private router: Router,
        public auth: AuthenticationService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        const statuses = await this.uow.lookups.statuses;
        this.jobTypes = await this.uow.getActiveJobTypes();
        await this.getData();
    }

    async getData() {
        this.jobs = await this.uow.getActiveJobs();
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        const filter = e.component.getCombinedFilter();
        if (e.component.__searchChanged || !!filter) {
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }
    async rowDoubleClick(e) {
        if (!e.data) return;
        await this.open(e.data.id);
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // if (!!e.data.highPriority) {
            //     // console.log('data', e);
            //     e.rowElement.className = e.rowElement.className + ' red-grid';
            // }
            if (e.data.jobType.color) {
                // console.log('data', e);
                e.rowElement.style.backgroundColor = e.data.jobType.color;
            }
        }
    }

    async open(id?: number) {
        this.router.navigate(['/jobs/' + (!!id ? id : 'new')]);
    }

    async addTime() {
        const modalRef = this.modalService.show(TimeAddDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                employeeId: this.auth.userValue.employeeId,
                mode: 'add',
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result && result.success) {
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
        });
    }
}
